export const HANDLE_MENU_OC = "HANDLE_MENU_OC";
export const OPEN_MENU_OC = "OPEN_MENU_OC";
export const CLOSE_MENU_OC = "CLOSE_MENU_OC";
export const HANDLE_INFOBOTTOM_OC = "HANDLE_INFOBOTTOM_OC";
export const GET_ERRORS = "GET_ERRORS";
export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const IS_LOADING = "IS_LOADING";
export const PAGE_TOOLBAR = "PAGE_TOOLBAR";
export const ACTIVATE_ANALISI = "ACTIVATE_ANALISI";
export const RESET_DISPLAY_MODE = "RESET_DISPLAY_MODE";
export const GET_CASES = "GET_CASES";
export const GET_PROJECTS = "GET_PROJECTS";
export const SET_ACTIVE_CHECKBOXES = "SET_ACTIVE_CHECKBOXES";
export const GET_INFRA_CREAZIONE = "GET_INFRA_CREAZIONE";
export const SET_ANALYSIS = "SET_ANALYSIS";
export const RESET_ANALYSIS = "RESET_ANALYSIS";
export const UPDATE_CREATE_PARAMS = "UPDATE_CREATE_PARAMS";
export const UPDATE_ANALYSIS_PARAMS = "UPDATE_ANALYSIS_PARAMS";
export const DEFAULT_PARAMS_CREATE = "DEFAULT_PARAMS_CREATE";
export const GET_LOADS = "GET_LOADS";
export const DELETE_RESULTS = "DELETE_RESULTS";
export const GET_CONFIGURATIONS_MAP = "GET_CONFIGURATIONS_MAP";
export const GET_INPUT_DATA = "GET_INPUT_DATA";

// export const API_URL = `http://polito-res.gdpanalytics.local:8000/api`;
// export const GEOSERVER_API_URL = "http://geoserver:8080/geoserver/res/wms";
// export const URL_WRAPPER = `http://localhost:3000/wrapper`;

export const GEOSERVER_API_URL = "https://geoserver.est.polito.it/geoserver/res/wms";
export const API_URL = "https://res.est.polito.it/api";
export const URL_WRAPPER = "https://energyplat.est.polito.it/wrapper";
